import { z } from 'zod';
import { ZodArrayToEnum } from '@axiom/types';
import { CandidatesConst, Pronouns } from '@axiom/const';

import { CandidateIndustrySchema } from './candidate-industry';

const CandidateAvailabilityStatuses = Object.keys(
  CandidatesConst.AvailabilityStatuses
) as Array<keyof typeof CandidatesConst.AvailabilityStatuses>;

const CandidatePronouns = Object.keys(Pronouns) as Array<keyof typeof Pronouns>;

// Created New Schema for to fix circular dependency issue
export const CandidateOpportunitiesCandidateSchema = z.object({
  availabilityStatus: z
    .enum(ZodArrayToEnum(CandidateAvailabilityStatuses))
    .nullish(),
  calculatedDisplayName: z.string().nullable(),
  id: z.string().uuid(),
  industries: z.array(CandidateIndustrySchema).nullable(),
  primaryFocusArea: z.string().nullable(), // No direct access to these enums
  primaryPracticeArea: z.string().nullable(), // No direct access to these enums
  profileImageKey: z.string().max(255).nullable(),
  pronouns: z.enum(ZodArrayToEnum(CandidatePronouns)).nullish(),
  publicRefId: z.number().int().positive(),
  yearsOfExperience: z.number().nonnegative().int().nullable(),
});

export type CandidateOpportunitiesCandidate = z.infer<
  typeof CandidateOpportunitiesCandidateSchema
>;
